import {computeFixedHeaderOffset} from "./computeFixedHeaderOffset";

const num = (v: string) => {
  const n = parseFloat(v)
  return Number.isFinite(n) ? n : 0
}

// Bring the element into view within any scrollable ancestor (e.g. the horizontal-timeline
// strip, or a capped card's internal vertical scroll). The window scroll handled below only
// moves the page vertically, so without this an off-screen card in a horizontal strip would
// never come into view. A no-op in vertically-stacked layouts where events have no scroll parent.
function scrollScrollParentsIntoView(el: Element) {
  let node = el.parentElement
  while (node && node !== document.body && node !== document.documentElement) {
    const style = getComputedStyle(node)
    const isWidgetRoot = node.classList.contains("tik4-live")
    const elRect = el.getBoundingClientRect()
    const ncRect = node.getBoundingClientRect()
    const canX = /(auto|scroll)/.test(style.overflowX) && node.scrollWidth > node.clientWidth + 1
    const canY = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1
    if (canX) {
      const target = node.scrollLeft + (elRect.left - ncRect.left) - num(style.scrollPaddingLeft)
      const max = node.scrollWidth - node.clientWidth
      node.scrollTo({left: Math.max(0, Math.min(max, target)), behavior: "smooth"})
    }
    if (canY) {
      const target = node.scrollTop + (elRect.top - ncRect.top) - num(style.scrollPaddingTop)
      const max = node.scrollHeight - node.clientHeight
      node.scrollTo({top: Math.max(0, Math.min(max, target)), behavior: "smooth"})
    }
    // Stop at the widget root so we never scroll the customer's surrounding page containers;
    // the page is moved by the window scroll below.
    if (isWidgetRoot) break
    node = node.parentElement
  }
}

// Why double requestAnimationFrame?
// - The first requestAnimationFrame schedules work after the current rendering cycle
// - The second requestAnimationFrame ensures all layout and paint operations are complete
// - This guarantees that element positions are accurate and stable before we calculate scroll positions

export function scrollToElement(el: Element, options?: { topOffset?: number }) {
  if (el) {
    // Wait for next animation frame to ensure layout is complete
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollScrollParentsIntoView(el);
        var eventClientRect = el.getBoundingClientRect();
        var headerOffset = options?.topOffset || computeFixedHeaderOffset() || 0;
        var top = window.scrollY + eventClientRect.top - headerOffset;

        // If element is at top due to initial render, scroll to bring it into better view
        if (eventClientRect.top < 10 && eventClientRect.top > -10) {
          // Calculate the element's absolute position in the document
          const absoluteTop = window.scrollY + eventClientRect.top;
          // Scroll to position with header offset
          top = Math.max(0, absoluteTop - headerOffset - 100) // 100px buffer from top
        }

        // Only scroll if we're not already there (within 5px tolerance)
        if (Math.abs(eventClientRect.top - headerOffset) > 5) {
          if (window && typeof window.tickarooLiveblogScrollTo === 'function') {
            window.tickarooLiveblogScrollTo(top)
          } else {
            window.scrollTo({
              behavior: "smooth",
              top: top
            });
          }
        }
      })
    })
  }
}
